import { api } from 'api/api';
import type { BaseResponse } from 'api/api.types';
import type { GetBranchDetailForMainPopUpResponseDto } from './dtos/getBranchDetailForMainPopUp.dto';

export async function getBranchDetailForMainPopUp(branchSeq: number) {
  const { data } = await api.get<BaseResponse<GetBranchDetailForMainPopUpResponseDto>>(`/branch/getBranchs/MainPop/${branchSeq}`);
  return data.data;
}
